module.exports = __webpack_public_path__ + "img/16.ee5b8eb0.jpg";